import type { IconSvgObject } from './types';

const SquareArrowDiagonal01Icon: IconSvgObject = [
  ["path", { d: "M10.5 16.5H7.5V13.5M13.5 7.5H16.5V10.5M8 16L16 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.5 4.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SquareArrowDiagonal01Icon;
